// extracted by mini-css-extract-plugin
module.exports = {"templateLink":"styles_templateLink__1Zouj","templateName":"styles_templateName__2Xl09","templateDate":"styles_templateDate__ZgRdS"};